import React from "react";
import "./Testimonials.css";

import {
  FaInstagram,
  FaLinkedinIn,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";

import malika from "../assets/team/maika1.jpeg";
import siddharth from "../assets/team/Sidhart1.jpeg";
import shaizad from "../assets/team/SHAIZAD ALI.jpg";
import anuj from "../assets/team/ANUJ.jpg";
import vidhant from "../assets/team/VIDHANT.jpg";
import viraj from "../assets/team/VIRAJ.jpg";
import prince from "../assets/team/PRINCE.jpg";
import manish from "../assets/team/MANISH.jpg";
import shon from "../assets/team/SHON.jpg";
import ayesha from "../assets/team/AYESHA.jpg";
import pritish from "../assets/team/Pritish-3.jpg";
import anand from "../assets/team/anand-3.jpg";
import chetan from "../assets/team/Chetan-3.jpg";
function Team() {
  const teamMembers = [
    {
      name: "MALIKA DANG",
      role: "CEO, Co-founder (Destroyer of Mediocrity) ",
      image: malika,
      instagram:
        "https://www.instagram.com/dang.malika?igsh=MXc1cWowbW9zbjZ5bA==",
      linkedin:
        "https://www.linkedin.com/in/malika-dang-7b584a311",
    },
    {
      name: "Siddharth Gautam",
      role: "CCO, Co-founder (Creatively Unsatisfied Forever)",
      image: siddharth,
      instagram:
        "https://www.instagram.com/sidd_gotham?utm_source=qr&igsh=amRlOGppa21ubzNt",
      linkedin:
        "https://www.linkedin.com/in/siddharth-gautam-7a144a18b",
    },
    {
      name: "Pritish Bari ",
      role: "Social Media Executive (Chronically Suffering From Viral)",
      image: pritish,
    },
    {
      name: "Shon Chetia",
      role: "Social Media Manager",
      image: shon,
    },
   
    {
      name: "Prince G",
      role: "Head of Post Production (Lord of Timelines)",
      image: prince,
    },
    {
      name: "Anand Gautam",
      role: " Creative Editor (Final_Final_Actually_Final) ",
      image: anand,
    },
    
    {
      name: "Shaizad Ali",
      role: "Director of Photography (Collector of Golden Hours) ",
      image: shaizad,
    },
    
    {
      name: "Anuj Yadav",
      role: "Content Cinematographer (Powered By Gimbals)",
      image: anuj,
    },
    {
      name: "Vidhant Kadam",
      role: "Creative Cinematographer/Photographer (Makes Sunlight Behave) ",
      image: vidhant,
    },
    {
      name: "Viraj Rathod",
      role: " Creative Photographer (Can You Lean Left?) ",
      image: viraj,
    },

    {
      name: "Manish Rathore",
      role: "Production Manager (Currently On Another Call) ",
      image: manish,
    },
 {
      name: "Chetan Pagare",
      role: " Lead Designer (Negative Space Enthusiast)",
      image: chetan,
    },
     {
      name: "Ayesha Ali",
      role: "Project Manager (Keeper of Deadlines)",
      image: ayesha,
    },
   
  ];

  return (
    <section className="team-section" id="team">

      {/* BACKGROUND */}

      <div className="team-glow team-glow-one"></div>
      <div className="team-glow team-glow-two"></div>

      <div className="team-container">

        {/* HEADER */}

        <div className="team-header">

          <div className="team-eyebrow">
            <span></span>
            THE PEOPLE BEHIND THE CULTURE
            <span></span>
          </div>

          <h2 className="team-title">
            Meet the minds
            <br />
            <em>behind the magic.</em>
          </h2>

          <p className="team-description">
            A collective of strategists, creators, storytellers,
            photographers and filmmakers who turn ideas into
            culture.
          </p>

        </div>


        {/* TEAM GRID */}

        <div className="team-grid">

          {teamMembers.map((member, index) => (

            <article
              className={`team-card ${index === 0
                  ? "team-card-featured"
                  : ""
                }`}
              key={member.name}
            >




              {/* IMAGE */}

              <div className="team-img-box">

                <img
                  src={member.image}
                  alt={member.name}
                  loading="lazy"
                />

                <div className="team-image-overlay"></div>


                {/* SOCIAL LINKS */}

                {(member.instagram || member.linkedin) && (

                  <div className="team-socials">

                    {member.instagram && (
                      <a
                        href={member.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} Instagram`}
                      >
                        <FaInstagram />
                      </a>
                    )}

                    {member.linkedin && (
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} LinkedIn`}
                      >
                        <FaLinkedinIn />
                      </a>
                    )}

                    {member.facebook && (
                      <a
                        href={member.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} Facebook`}
                      >
                        <FaFacebookF />
                      </a>
                    )}

                    {member.youtube && (
                      <a
                        href={member.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} YouTube`}
                      >
                        <FaYoutube />
                      </a>
                    )}

                  </div>

                )}

              </div>


              {/* CONTENT */}

             <div className="team-content">

  <div className="team-role">
    {member.role.split("(")[0].trim()}
  </div>

  <h3>
    {member.name.toUpperCase()}
  </h3>

  {member.role.includes("(") && (
    <div className="team-tagline">
      {member.role.match(/\((.*?)\)/)?.[1]}
    </div>
  )}

  <div className="team-card-line"></div>

</div>

            </article>

          ))}

        </div>


        {/* BOTTOM STATEMENT */}

        <div className="team-bottom">

          <div className="team-bottom-line"></div>

          <span>
            ONE TEAM. MANY PERSPECTIVES.
          </span>

          <div className="team-bottom-line"></div>

        </div>

      </div>

    </section>
  );
}

export default Team;



// import React, { useEffect, useState } from "react";

// import "./Testimonials.css";

// import {
//   FaInstagram,
//   FaLinkedinIn,
//   FaFacebookF,
// } from "react-icons/fa";

// const API_URL = "http://localhost:5000";

// function Team() {
//   const [teamMembers, setTeamMembers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ==========================================
//   // FETCH ACTIVE TEAM MEMBERS
//   // ==========================================

//   useEffect(() => {
//     let isMounted = true;

//     const fetchTeamMembers = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const response = await fetch(
//           `${API_URL}/api/team/active`
//         );

//         const result = await response.json();

//         if (!response.ok || !result.success) {
//           throw new Error(
//             result?.message ||
//               "Unable to load team members"
//           );
//         }

//         if (isMounted) {
//           const members = Array.isArray(result.data)
//             ? result.data
//             : [];

//           // Safety sort — lower displayOrder first
//           members.sort((a, b) => {
//             const orderA = Number(a.displayOrder) || 0;
//             const orderB = Number(b.displayOrder) || 0;

//             if (orderA !== orderB) {
//               return orderA - orderB;
//             }

//             return (
//               new Date(a.createdAt || 0) -
//               new Date(b.createdAt || 0)
//             );
//           });

//           setTeamMembers(members);
//         }
//       } catch (err) {
//         console.error("Team API error:", err);

//         if (isMounted) {
//           setError(
//             err.message ||
//               "Unable to load team members."
//           );
//         }
//       } finally {
//         if (isMounted) {
//           setLoading(false);
//         }
//       }
//     };

//     fetchTeamMembers();

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   return (
//     <section className="team-section" id="team">

//       {/* ==========================================
//           BACKGROUND
//       ========================================== */}

//       <div className="team-glow team-glow-one"></div>
//       <div className="team-glow team-glow-two"></div>

//       <div className="team-container">

//         {/* ==========================================
//             HEADER
//         ========================================== */}

//         <div className="team-header">

//           <div className="team-eyebrow">
//             <span></span>
//             THE PEOPLE BEHIND THE CULTURE
//             <span></span>
//           </div>

//           <h2 className="team-title">
//             Meet the minds
//             <br />
//             <em>behind the magic.</em>
//           </h2>

//           <p className="team-description">
//             A collective of strategists, creators,
//             storytellers, photographers and filmmakers
//             who turn ideas into culture.
//           </p>

//         </div>

//         {/* ==========================================
//             LOADING
//         ========================================== */}

//         {loading && (
//           <div className="team-loading">
//             <div className="team-loading-inner">
//               <span className="team-loading-dot"></span>
//               <span className="team-loading-dot"></span>
//               <span className="team-loading-dot"></span>
//             </div>

//             <p>Loading our people...</p>
//           </div>
//         )}

//         {/* ==========================================
//             ERROR
//         ========================================== */}

//         {!loading && error && (
//           <div className="team-empty">
//             <h3>Unable to load the team</h3>
//             <p>{error}</p>
//           </div>
//         )}

//         {/* ==========================================
//             EMPTY
//         ========================================== */}

//         {!loading &&
//           !error &&
//           teamMembers.length === 0 && (
//             <div className="team-empty">
//               <h3>No team members available</h3>
//               <p>
//                 Team members will appear here once
//                 they are added from the admin panel.
//               </p>
//             </div>
//           )}

//         {/* ==========================================
//             TEAM GRID
//         ========================================== */}

//         {!loading &&
//           !error &&
//           teamMembers.length > 0 && (
//             <div className="team-grid">

//               {teamMembers.map((member, index) => {
//                 const name = member.name || "";

//                 const role =
//                   member.designation || "";

//                 const tagline =
//                   member.tagline || "";

//                 const image =
//                   member.image || "";

//                 const instagram =
//                   member.instagram || "";

//                 const linkedin =
//                   member.linkedin || "";

//                 const facebook =
//                   member.facebook || "";

//                 return (
//                   <article
//                     className={`team-card ${
//                       index === 0
//                         ? "team-card-featured"
//                         : ""
//                     }`}
//                     key={
//                       member._id ||
//                       `${name}-${index}`
//                     }
//                   >

//                     {/* ==========================================
//                         IMAGE
//                     ========================================== */}

//                     <div className="team-img-box">

//                       {image ? (
//                         <img
//                           src={image}
//                           alt={name}
//                           loading={
//                             index === 0
//                               ? "eager"
//                               : "lazy"
//                           }
//                         />
//                       ) : (
//                         <div className="team-image-placeholder">
//                           <span>
//                             {name
//                               .charAt(0)
//                               .toUpperCase()}
//                           </span>
//                         </div>
//                       )}

//                       <div className="team-image-overlay"></div>

//                       {/* ==========================================
//                           SOCIAL LINKS
//                       ========================================== */}

//                       {(instagram ||
//                         linkedin ||
//                         facebook) && (
//                         <div className="team-socials">

//                           {instagram && (
//                             <a
//                               href={instagram}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               aria-label={`${name} Instagram`}
//                             >
//                               <FaInstagram />
//                             </a>
//                           )}

//                           {linkedin && (
//                             <a
//                               href={linkedin}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               aria-label={`${name} LinkedIn`}
//                             >
//                               <FaLinkedinIn />
//                             </a>
//                           )}

//                           {facebook && (
//                             <a
//                               href={facebook}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               aria-label={`${name} Facebook`}
//                             >
//                               <FaFacebookF />
//                             </a>
//                           )}

//                         </div>
//                       )}

//                     </div>

//                     {/* ==========================================
//                         CONTENT
//                     ========================================== */}

//                     <div className="team-content">

//                       <div className="team-role">
//                         {role}
//                       </div>

//                       <h3>
//                         {name.toUpperCase()}
//                       </h3>

//                       {tagline && (
//                         <div className="team-tagline">
//                           {tagline}
//                         </div>
//                       )}

//                       <div className="team-card-line"></div>

//                     </div>

//                   </article>
//                 );
//               })}

//             </div>
//           )}

//         {/* ==========================================
//             BOTTOM STATEMENT
//         ========================================== */}

//         <div className="team-bottom">

//           <div className="team-bottom-line"></div>

//           <span>
//             ONE TEAM. MANY PERSPECTIVES.
//           </span>

//           <div className="team-bottom-line"></div>

//         </div>

//       </div>
//     </section>
//   );
// }

// export default Team;